import React from 'react';
import { Tag } from 'antd';

/* ------------------------------------------------------------------ */
/*  Invoice / Sale status badge values.
 *
 *  Combines the lifecycle envelope (`status`: active/on_hold/cancelled),
 *  workflow phase (`status_workflow`: draft/pending/confirmed/...) and
 *  payment status (`status_payment`: unpaid/partial/paid/...) so a single
 *  badge can render any of them in the customer-facing UI.
 */
/* ------------------------------------------------------------------ */
const INVOICE_STATUS_MAP = {
  // Envelope
  active:     { color: 'blue',       label: 'Active'    },
  on_hold:    { color: 'warning',    label: 'On Hold'   },
  cancelled:  { color: 'default',    label: 'Cancelled' },
  // Payment
  paid:       { color: 'success',    label: 'Paid'      },
  unpaid:     { color: 'warning',    label: 'Unpaid'    },
  overdue:    { color: 'error',      label: 'Overdue'   },
  partial:    { color: 'processing', label: 'Partial'   },
  refunded:   { color: 'default',    label: 'Refunded'  },
  // Workflow phase
  draft:      { color: 'default',    label: 'Draft'     },
  pending:    { color: 'default',    label: 'Pending'   },
  confirmed:  { color: 'processing', label: 'Confirmed' },
  sent:       { color: 'blue',       label: 'Sent'      },
  viewed:     { color: 'purple',     label: 'Viewed'    },
  completed:  { color: 'success',    label: 'Completed' },
};

/* ------------------------------------------------------------------ */
/*  Estimate status                                                     */
/* ------------------------------------------------------------------ */
const ESTIMATE_STATUS_MAP = {
  draft:     { color: 'default',  label: 'Draft'    },
  active:    { color: 'blue',     label: 'Active'   },
  sent:      { color: 'blue',     label: 'Sent'     },
  viewed:    { color: 'purple',   label: 'Viewed'   },
  accepted:  { color: 'success',  label: 'Accepted' },
  declined:  { color: 'error',    label: 'Declined' },
  converted: { color: 'cyan',     label: 'Invoiced' },
  expired:   { color: 'warning',  label: 'Expired'  },
  cancelled: { color: 'default',  label: 'Cancelled'},
};

export const InvoiceStatusBadge = ({ status }) => {
  const map = INVOICE_STATUS_MAP[status?.toLowerCase()] ?? { color: 'default', label: status ?? '—' };
  return <Tag color={map.color} style={{ borderRadius: 4, fontWeight: 500 }}>{map.label}</Tag>;
};

export const PaymentStatusBadge = ({ status }) => {
  const map = INVOICE_STATUS_MAP[status?.toLowerCase()] ?? { color: 'default', label: status ?? '—' };
  return <Tag color={map.color} style={{ borderRadius: 4, fontWeight: 500 }}>{map.label}</Tag>;
};

export const EstimateStatusBadge = ({ status }) => {
  const map = ESTIMATE_STATUS_MAP[status?.toLowerCase()] ?? { color: 'default', label: status ?? '—' };
  return <Tag color={map.color} style={{ borderRadius: 4, fontWeight: 500 }}>{map.label}</Tag>;
};

export default InvoiceStatusBadge;
